import type { TranslateService } from '@ngx-translate/core';
import type { WebWidgetModel, WidgetMetaData } from '@web/types';
import type { TextEntity } from '@sites/entity-core';

import { Widgets } from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';
import { createText } from '@sites/entity-core';

import { TextViewComponent } from '../components/text-view/text-view.component';
import { TextControlComponent } from '../components/text-control/text-control.component';

// DEFAULT COMPONENT SETTINGS — sourced from the canonical entity factory in
// @sites/entity-core. The package owns the data shape; the seeded rich-text
// `content` (built from i18n strings) is the only host-only concern, passed in
// via `CreateLegacyTextOptions`.
//
// `data` is a function so `WebWidgetsFactoryService.prepareWidgetData` invokes
// it with `meta` — a text widget dropped into a zero block starts from the zero
// variant's defaults (`type: 'zero'` envelope tag, extended-position grid).
const textData = (translateService: TranslateService, meta?: WidgetMetaData): TextEntity['data'] => {
    const content = `<h2>${translateService.instant('text_element_header')}</h2>
              <p>${translateService.instant('text_element_text')}</p>`;

    const entity = meta?.type === 'zero' ? createText('zero', { content }) : createText('default', { content });

    return entity.data;
};
// END DEFAULT SETTINGS

export const textWidgetModel: WebWidgetModel = {
    componentView: TextViewComponent,
    componentControl: TextControlComponent,
    name: Widgets.TEXT,
    label: 'widget_text_label',
    data: textData,
    permission: defaultWidgetPermission,
    params: {
        ...defaultWidgetParams,
        showControls: false,
        type: ['default', 'specific', 'zero'],
    },
    signalForm: true,
};
